import API from '../..';
const ENTITY = 'contacts';

export const bulkContacts = (data) =>
    API.put(`/api/v1/${ENTITY}/bulk-status-flags/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
export const bulkReasignUser = (data) =>
    API.put(`/api/v1/${ENTITY}/bulk-reassign-user/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
export const createContact = (data) => API.post(`/api/v1/${ENTITY}/`, data);
export const exportFile = () =>
    API.get(`/api/v1/${ENTITY}/export-upload/`, {
        headers: { 'Content-Type': 'text/csv' },
    });
export const filterContacts = ({
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    searchText = '',
    sortBy = null,
    status = 'active',
    userId = null,
} = {}) =>
    API.get(`/api/v1/${ENTITY}/`, {
        params: {
            order_by: orderBy,
            page: page,
            per_page: perPage,
            search: searchText,
            sort: sortBy,
            status_flag: status,
            user: userId,
        },
    });
export const getContactsCatalog = () => API.get(`/api/v1/${ENTITY}-catalog/`);
export const getContact = (id) => API.get(`/api/v1/${ENTITY}/${id}/`);
export const importFile = (data) =>
    API.post(`/api/v1/${ENTITY}/export-upload/`, data);
export const updateContact = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}/`, data);
